import { useEffect, useState } from "react";
import { getNotifications, getUnreadCount, markAllRead, markNotificationRead } from "./NotificationService";
import "./NotificationsPanel.css";

export default function NotificationsPanel({ open, onClose }) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const load = async () => {
    const [items, count] = await Promise.all([getNotifications(), getUnreadCount()]);
    setNotifications(items);
    setUnreadCount(count);
  };

  useEffect(() => {
    if (open) {
      load();
    }
  }, [open]);

  const handleMarkRead = async (id) => {
    await markNotificationRead(id);
    load();
  };

  const handleMarkAll = async () => {
    await markAllRead();
    load();
  };

  if (!open) return null;

  return (
    <div className="notification-panel">
      <div className="notification-panel-header">
        <div>
          <div className="notification-title">Notifications</div>
          <div className="notification-subtitle">{unreadCount} unread</div>
        </div>
        <div className="notification-actions">
          <button className="notification-btn" type="button" onClick={handleMarkAll}>
            Mark all read
          </button>
          <button className="notification-btn ghost" type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
      <div className="notification-list">
        {notifications.length === 0 && (
          <div className="notification-empty">No notifications yet.</div>
        )}
        {notifications.map((note) => (
          <button
            key={note.id}
            type="button"
            className={`notification-item ${note.readFlag ? "read" : "unread"}`}
            onClick={() => handleMarkRead(note.id)}
          >
            <div className="notification-item-title">{note.title}</div>
            <div className="notification-item-message">{note.message}</div>
            <div className="notification-item-meta">
              {note.createdAt?.slice(0, 19)?.replace("T", " ")}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
